export const TID = {
  // nav
  navHome: "nav-home",
  navTrailers: "nav-trailers",
  navEvents: "nav-events",
  navHow: "nav-how",
  navGallery: "nav-gallery",
  navServiceArea: "nav-service-area",
  navFaqs: "nav-faqs",
  navBookCta: "nav-book-cta",
  navMobileToggle: "nav-mobile-toggle",
  // home
  heroBookBtn: "hero-book-btn",
  heroViewTrailersBtn: "hero-view-trailers-btn",
  homeQuickEstimateBtn: "home-quick-estimate-btn",
  // quick lead
  qlfName: "qlf-name",
  qlfEmail: "qlf-email",
  qlfPhone: "qlf-phone",
  qlfEventType: "qlf-event-type",
  qlfEventDate: "qlf-event-date",
  qlfEventCity: "qlf-event-city",
  qlfGuestCount: "qlf-guest-count",
  qlfTrailers: "qlf-trailers",
  qlfSubmit: "qlf-submit",
  // booking
  bookingNext: "booking-next",
  bookingBack: "booking-back",
  bookingSubmit: "booking-submit",
  bookingPay: "booking-pay",
  // admin
  adminEmail: "admin-email",
  adminPassword: "admin-pw-field",
  adminLoginBtn: "admin-login-btn",
  adminLogoutBtn: "admin-logout-btn",
};
